// extracted by css-extract-rspack-plugin
export default {"cls1":"ImpactNavBar-cls1_CzB","cls2":"ImpactNavBar-cls2_joQ ImpactNavBar-cls1_CzB"};